import { CommandBarButton, DefaultButton, DirectionalHint, IButtonProps, IButtonStyles, ICommandBarStyles, IconButton, Spinner, TooltipHost } from "@fluentui/react";
import { useEffect, useState } from "react";

interface ShareButtonProps extends IButtonProps {
    onClick: () => void;
  }

export const ShareButton: React.FC<ShareButtonProps> = ({onClick}) => {
    const shareButtonStyles: ICommandBarStyles & IButtonStyles = {
        root: {
          width: 86,
          height: 32,
          borderRadius: 4,
          background: 'radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)',
        //   position: 'absolute',
        //   right: 20,
          padding: '5px 12px',
          marginRight: '20px'
        },
        icon: {
          color: '#FFFFFF',
        },
        rootHovered: {
          background: 'linear-gradient(135deg, #0F6CBD 0%, #2D87C3 51.04%, #8DDDD8 100%)',
        },
        label: {
          fontWeight: 600,
          fontSize: 14,
          lineHeight: '20px',
          color: '#FFFFFF',
        },
      };

      return (
        <CommandBarButton
                styles={shareButtonStyles}
                iconProps={{ iconName: 'Share' }}
                onClick={onClick}
                text="Share"
        />
      )
}

interface HistoryButtonProps extends IButtonProps {
    onClick: () => void;
    text: string;
  }

export const HistoryButton: React.FC<HistoryButtonProps> = ({onClick, text}) => {
    const historyButtonStyles: ICommandBarStyles & IButtonStyles = {
        root: {
            width: '200px',
            border: `1px solid #D1D1D1`,
            padding: '5px 12px',
          },
          rootHovered: {
            border: `1px solid #D1D1D1`,
          },
          rootPressed: {
            border: `1px solid #D1D1D1`,
          },
      };

      return (
        <DefaultButton
            text={text}
            iconProps={{ iconName: 'History' }}
            onClick={onClick}
            styles={historyButtonStyles}
        />
      )
}

// 管理者Menuボタン
interface AdminMenuButtonProps extends IButtonProps {
  onClick: () => void;
}

export const AdminMenuButton: React.FC<AdminMenuButtonProps> = ({onClick}) => {
  const adminMenuButtonStyles: ICommandBarStyles & IButtonStyles = {
      root: {
          width: '170px',
          border: `1px solid #D1D1D1`,
          padding: '5px 12px',
        },
    };

    return (
      <DefaultButton
          iconProps={{ iconName: 'ContextMenu' }}
          onClick={onClick}
          styles={adminMenuButtonStyles}
          text="管理者メニュー"
          />
    )
}

// CSV出力ボタン
interface OutputCsvButtonProps extends IButtonProps {
  onClick: () => void;
}

export const OutputCsvButton: React.FC<OutputCsvButtonProps> = ({onClick}) => {
  const outputCsvButtonStyles: ICommandBarStyles & IButtonStyles = {
      root: {
          width: '180px',
          border: `1px solid #D1D1D1`,
          padding: '5px 12px',
          marginRight: '0px'
        },
    };

    return (
      <DefaultButton
          iconProps={{ iconName: 'CloudDownload' }}
          onClick={onClick}
          styles={outputCsvButtonStyles}
          text="履歴ダウンロード"
          />
    )
}

// RAGメニューボタン
interface RAGMenuButtonProps extends IButtonProps {
  onClick: () => void;
}

export const RAGMenuButton: React.FC<RAGMenuButtonProps> = ({onClick, text}) => {
  const RAGMenuButtonStyles: ICommandBarStyles & IButtonStyles = {
      root: {
          color: '#FFFFFF',
          backgroundColor: '#1E90FF',
          width: '220px',
          border: `1px solid #D1D1D1`,
          padding: '5px 12px',
          marginLeft: '10px',
          marginRight: '20px'
        },
    };

    return (
      <DefaultButton
          text={text}
          iconProps={{ iconName: 'PDF' }}
          onClick={onClick}
          styles={RAGMenuButtonStyles}
          />
    )
}


// ログアウトボタン
interface LogoutButtonProps extends IButtonProps {
  onClick: () => void;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({onClick}) => {
  const logoutButtonStyles: ICommandBarStyles & IButtonStyles = {
      root: {
          width: '130px',
          border: `1px solid #D1D1D1`,
          padding: '5px 12px',
          marginRight: '20px'
        },
    };

    return (
      <DefaultButton
          iconProps={{ iconName: 'SignOut' }}
          onClick={onClick}
          styles={logoutButtonStyles}
          text="ログアウト"
          />
    )
}

interface LoginButtonProps extends IButtonProps {
  onClick: () => void;
}

export const LoginButton: React.FC<LoginButtonProps> = ({onClick}) => {
  const loginButtonStyles: ICommandBarStyles & IButtonStyles = {
      root: {
          width: '100px',
          border: `1px solid #D1D1D1`,
          padding: '5px 12px',
          marginRight: '20px',
          background: 'radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)',
          borderRadius: 4
        },
    };

    return (
      <DefaultButton
          iconProps={{ iconName: 'Signin' }}
          onClick={onClick}
          styles={loginButtonStyles}
          text="Login"
          />
    )
}

interface CopyButtonProps extends IButtonProps {
  copyText: string;
  testId?: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({copyText, style, testId}) => {
  const CopyButtonStyles: IButtonStyles = {
    root: {
      minWidth: '30px',
      border: 0,
      borderRadius: 4,
      padding: '0 4px',
      backgroundColor: "transparent",
    },
  };

  const [isCopy, setIsCopy] = useState(false);
  const copyAnswerText = async (copyText: string) => {
      await navigator.clipboard.writeText(copyText);
      setIsCopy(true)
      setTimeout(() => {
          setIsCopy(false);
      }, 2000);
  }

  return (
    <TooltipHost
      content="コピーする"
      directionalHint={DirectionalHint.bottomCenter}
    >
      <DefaultButton
        iconProps={{ iconName: isCopy ? 'BoxCheckmarkSolid' : 'Copy' }}
        onClick={() => copyAnswerText(copyText)}
        styles={CopyButtonStyles}
        data-testid={testId}
        data-copied={isCopy}
      />
    </TooltipHost>
  )
}

/** チャット横のボタンコンポーネント */
export const ChatActionButton: React.FC<IButtonProps> = ({
  iconProps,
  menuProps,
  onClick,
  disabled,
  "aria-label": ariaLabel,
}) => {
  return (
    <CommandBarButton
      role="button"
      styles={{
        icon: {
          color: "#FFFFFF",
        },
        root: {
          boxSizing: "border-box",
          justifyContent: "center",
          alignItems: "center",
          width: 40,
          height: 40,
          color: "#FFFFFF",
          border: "1px solid #D1D1D1",
          borderRadius: 4,
          zIndex: 1,
          background:
            "radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)",
        },
        rootDisabled: {
          background: "#BDBDBD",
        },
        iconHovered: {
          color: "#AAAAAA",
        },
        menuIcon: menuProps ? { display: "none" } : undefined,
      }}
      iconProps={iconProps}
      menuProps={menuProps}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    />
  );
};


interface LongProcessButtonProps extends IButtonProps {
  onClick: () => Promise<void>;
  title: string
  icon: string
  testId?: string
}

export const LongProcessButton: React.FC<LongProcessButtonProps> = (props: LongProcessButtonProps) => {
  const {onClick, title, icon, testId} = props
  const [isProcessing, setIsProcessing] = useState(false)
  const onClickOverride = async () => {
    setIsProcessing(true)
    await onClick()
    setIsProcessing(false)
  }
  return (
    <>
      {
        isProcessing ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px' }}>
            <Spinner />
          </div>
        ) : 
        <IconButton
          title={title}
          className={props.className}
          iconProps={{ iconName: icon }}
          onClick={onClickOverride}
          data-testid={testId}
        />
      }
    </>
  )
}